(function ($, generic) {
  Drupal.behaviors.giftCardBalanceUKV1 = {
    attach: function (context) {
      const $giftCardContext = $('.js-giftcard-balance-block', context);
      const $giftCardForm = $('.js-giftcard-balance-block__form', $giftCardContext);
      const $giftCardSubmitCTA = $('.js-giftcard-submit-cta', $giftCardContext);
      const $giftCardBalanceError = $('.js-giftcard_balance_error', $giftCardContext);
      const $giftCardBalanceDetails = $('.js-giftcard-balance-details', $giftCardContext);
      const $giftCardBalanceInputField = $('.js-giftcard-balance-input-field', $giftCardContext);
      const $giftCardBalanceRemaining = $('.js-giftcard-balance-block__result--amount', $giftCardContext);
      const $giftCardBalanceCardNumberEnding = $('.js-giftcard-balance-block__result--number-ending', $giftCardContext);
      const $giftCardBalanceCheckAgain = $('.js-giftcard-balance-block__cta--recheck', $giftCardContext);

      if (!$giftCardForm.length) {
        return false;
      }

      const toogleGiftCardSections = function (toogle) {
        if (toogle) {
          $giftCardForm.addClass('hidden');
          $giftCardBalanceDetails.removeClass('hidden');
        } else {
          $giftCardBalanceDetails.addClass('hidden');
          $giftCardForm.removeClass('hidden');
          $giftCardBalanceError.addClass('hidden');
        }
      };
      const disableGiftCardCTA = function (state) {
        if (state) {
          $giftCardSubmitCTA.attr('disabled', true);
          $giftCardSubmitCTA.addClass('giftcard-submit-disable');
        } else {
          $giftCardSubmitCTA.attr('disabled', false);
          $giftCardSubmitCTA.removeClass('giftcard-submit-disable');
          $('input[type=text]', $giftCardForm).val('');
        }
      };

      $giftCardBalanceCheckAgain.on('click', function () {
        toogleGiftCardSections(false);
      });

      $giftCardSubmitCTA.on('click', function (evt) {
        evt.preventDefault();
        const GC_GIFTCARD_NUMBER = $('[name=GC_GIFTCARD_NUMBER]', $giftCardForm).val();
        const GC_GIFTCARD_PIN = $('[name=GC_GIFTCARD_PIN]', $giftCardForm).val();

        if (GC_GIFTCARD_NUMBER === '' || GC_GIFTCARD_PIN === '') {
          return false;
        }
        disableGiftCardCTA(true);
        const params = {
          _SUBMIT: 'giftcard_balance',
          GC_GIFTCARD_NUMBER: GC_GIFTCARD_NUMBER,
          GC_GIFTCARD_PIN: GC_GIFTCARD_PIN
        };

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [params],
          onSuccess: function (jsonRpcResponse) {
            const data = jsonRpcResponse.getData();

            $giftCardBalanceInputField.removeClass('error');
            toogleGiftCardSections(true);
            if (data.formatted_balance) {
              $giftCardBalanceRemaining.text(data.formatted_balance);
              $giftCardBalanceCardNumberEnding.text(data.giftcard_number.toString().slice(-4));
            }
            disableGiftCardCTA(false);
          },
          onFailure: function (jsonRpcResponse) {
            const errorResponse = jsonRpcResponse.getMessages();

            if (errorResponse.length > 0) {
              $giftCardBalanceError.text($giftCardBalanceError.data('invalid-gc-error-message'));
              $giftCardBalanceError.removeClass('hidden');
              $giftCardBalanceInputField.addClass('error');
            }
            disableGiftCardCTA(false);
          }
        });
      });
    }
  };
})(jQuery, window.generic || {});
